<template>
  <div>
    <v-row>
      <v-col cols="12">
        <data-table
            ref="table"
            :headers="headers"
            :items="items"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item.quantity="{ item }">
            {{ item.quantity }} {{ wantBuy.category.unit }}
          </template>
        </data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../services/api';
import DataTable from "@/components/data-table/DataTable";
import formatters from '@/mixins/formatters';
import permissions from '@/mixins/permissions';

export default {
  mixins: [
    formatters,
    permissions,
  ],
  components: {
    DataTable,
  },
  props: ['id'],
  data() {
    return {
      total: 0,
      options: {},
      items: [],
      wantBuy: null,
      loading: true,
      headers: [
        {text: 'Ilość', value: 'quantity', sortable: false},
        {text: 'E-mail', value: 'email', sortable: false},
        {text: 'Telefon', value: 'phone', sortable: false},
      ],
    }
  },
  methods: {
    async getList() {
      this.loading = true;

      const {page, itemsPerPage} = this.options;

      const params = {
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      const response = await api.get(`/api/offer/want-buys/${this.id}/have`, {params});
      this.loading = false;

      this.items = response.data.items;
      this.total = response.data.total; // Delay the change a bit to avoid performing another query.
    },

    async getWantBuy() {
      this.loading = true;

      const response = await api.get(`/api/offer/want-buys/${this.id}`);
      await this.getList();
      this.loading = false;

      this.wantBuy = response.data;
    },
  },
  beforeRouteUpdate(to, from, next) {
    next(); // Update the URL in address bar.
    this.getWantBuy();
  },
  async created() {
    try {

      await this.getWantBuy();
    } catch (e) {
      void (0);
    }
  },
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-chip {
  white-space: break-spaces !important;
  line-height: 14px;
  width: 100%;
  padding: 9px;
}

.v-chip .v-chip__content {
  max-width: 100%;
  height: auto;
  overflow: auto;
  min-height: 32px;
  white-space: pre-wrap;
}
</style>